import { GENERIC_LANDING_CONFIG } from "./openDoorEvents";

export const ADMIN_EVENTS = [
  {
    id: GENERIC_LANDING_CONFIG.firebaseDocId,
    label: GENERIC_LANDING_CONFIG.eventName,
    type: "ranger",
  },
  {
    id: "evento-estadio",
    label: "Torneo de Metegol",
    type: "metegol",
  },
];

export const DEFAULT_ADMIN_EVENT_ID = GENERIC_LANDING_CONFIG.firebaseDocId;

export function getAdminEvent(eventId) {
  return ADMIN_EVENTS.find((e) => e.id === eventId) || ADMIN_EVENTS[0];
}
